import Vue from 'vue'
import VueRouter from 'vue-router'

import MainBase from '../MainBase.vue'
import AddFunds from '../views/AddFunds.vue'
import Progress from '../views/Progress.vue'
import SetGoal from '../views/SetGoal.vue'

import SetupBase from '../SetupBase.vue'
import Splash from '../views/Splash.vue'
import AccountSelect from '../views/AccountSelect.vue'
import Settings from '../views/Settings.vue'
import Transfers from '../views/Transfers.vue'
import TransferHistory from '../views/TransferHistory.vue'
import AllTips from '../views/AllTips.vue'
import PreQualify from '../views/PreQualify.vue'
import Notifications from '../views/Notifications.vue'

import store from '../store'

Vue.use(VueRouter)

const routes = [
    // { 
    //     path: '/',
    //     name: 'fakemain',
    //     component: MainBase,
    //     children: [
    //         {
    //             path: '',
    //             name: 'set-goal',
    //             component: SetGoal,
    //             meta: {
    //                 pageName: 'Set Your Goal',
    //             },
    //         },
    //     ],
    // },
    {
        path: '/main/',
        name: 'main',
        component: MainBase,
        children: [
            {
                path: 'add-funds',
                name: 'add-funds',
                component: AddFunds,
                meta: {
                    pageName: 'Add Funds'
                }
            },
            {
                path: 'progress',
                name: 'progress',
                component: Progress,
                meta: {
                    pageName: 'Progress'
                }
            },
            {
                path: 'set-goal',
                name: 'set-goal',
                component: SetGoal,
                meta: {
                    pageName: 'Set Your Goal'
                }
            },
            {
                path: 'account-select',
                name: 'account-select',
                component: AccountSelect,
                meta: {
                    pageName: 'Select Account'
                }
            },
            {
                path: 'settings',
                name: 'settings',
                component: Settings,
                meta: {
                    pageName: 'Settings'
                }
            },
            {
                path: 'transfers',
                name: 'transfers',
                component: Transfers,
                meta: {
                    pageName: 'Transfers'
                }
            },
            {
                path: 'transfer-history',
                name: 'transfer-history',
                component: TransferHistory,
                meta: {
                    pageName: 'Transfer History'
                }
            },
            {
                path: 'all-tips',
                name: 'all-tips',
                component: AllTips,
                meta: {
                    pageName: 'Savings Tips'
                }
            },
            {
                path: 'pre-qualify',
                name: 'pre-qualify',
                component: PreQualify,
                meta: {
                    pageName: 'Pre-Qualify'
                }
            },
            {
                path: 'notifications',
                name: 'notifications',
                component: Notifications,
                meta: {
                    pageName: 'Notifications'
                }
            },
        ],
    },

    {
        path: '/setup/',
        name: 'setup-screens',
        component: SetupBase,
        children: [
            {
                path: 'login',
                name: 'splash',
                component: Splash,
                meta: {
                    pageName: ''
                }
            },
        ]
    },
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.pageName) {
        store.dispatch('setPageName', to.meta.pageName)
    }

    let user = store.state.user
    if (!user && to.path != '/setup/login') {
        next('/setup/login')
        return
    }
    else if (!!user && to.path == '/setup/login') {
        next('/main/add-funds')
        return 
    }
    else if (to.path == '/') {
        next('/main/add-funds')
        return 
    }

    next();
});

export default router
